import { ON_ADD_PAYMENT, ON_ADD_PAYMENT_SUCCESS } from "../../constants/ActionTypes";

const INIT_STATE = {
  loader: false,
  url: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ON_ADD_PAYMENT_SUCCESS: {
      return {
        ...state,
        loader: false,
        url: action.payload
      }
    }
    case ON_ADD_PAYMENT: {
      return {
        ...state,
        loader: true
      }
    }
    default:
      return state;
  };
}
